module.exports = __webpack_public_path__ + "static/img/bg4.ed605b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/bg4.jpg
// module id = lUxA
// module chunks = 0